import { Header } from 'components/header'
import React, { ReactElement, useEffect, useState } from 'react'
import {
  JSONFileMunicipalCouncil,
  PercentagePerParty
} from 'types/gemeindeRatWahlanteileFile'
import { TrendRow } from './trendRow'

export default function index(): ReactElement {
  const [data, setData] = useState<JSONFileMunicipalCouncil | null>()
  function getData() {
    fetch(
      'https://wch-interactive.storage.googleapis.com/votations-2022-vd/grandConseil-trend-2022-grouped.json'
    ).then(res =>
      res.json().then((fetchedData: JSONFileMunicipalCouncil) => {
        const sortedData = fetchedData.percentagePerParty.sort(
          (a, b) => b.changePercentage - a.changePercentage
        )
        const sortedDataWithoutOthers = sortedData.filter(
          row => row.orderFromLeftToRight < 999
        )
        // const others = sortedData.filter(row => row.orderFromLeftToRight > 999)
        fetchedData.percentagePerParty = sortedDataWithoutOthers
        setData(fetchedData)
      })
    )
  }
  useEffect(() => {
    const intervalId = setInterval(() => getData(), 10000)
    getData()
    return () => {
      clearInterval(intervalId)
    }
  }, [])
  return (
    <>
      {data && (
        <>
          <Header
            title={data.meta.trend.title}
            description={data.meta.trend.description}
            doneMunicipalCouncil={data.meta.doneMunicipalCouncil}
            countStatus={data.meta.countStatus}
          />
          {data.percentagePerParty.map(row => {
            return (
              <TrendRow
                key={row.party}
                party={row.party}
                changePercentage={(row.changePercentage * 100).toFixed(2)}
                color={row.color}
                trendBarMaxValue={+data.trendBarMaxValue}
              />
            )
          })}
          <small>
            <b>Note</b>: Les formations du centre regroupées font le même score
            qu’en 2017
          </small>
        </>
      )}
    </>
  )
}
